import {SC_Input} from '../input/SC_Input';
import {Hip} from './Hip';
import {PartialHip} from './PartialHip';
import {Rectangular} from './Rectangular';

export class AreaFinder {
    public static PULT: number = 0;
    public static SATTEL: number = 1;
    public static WALM: number = 2;
    public static SCHED: number = 3;
    public static KRUEPPELWALM: number = 4;
    public static MANSARD: number = 5;

    static getAreaByModule(oMod: any): string {
        let sRet: string = '';
        //no range
        if (SC_Input.bNoRange) {
            return 'h';
        }
        if (SC_Input.iRoofShape == this.PULT) {
            // sRet = Rectangular.getRangeByModule(oMod);
            sRet = this.Rect_getRangeByModule(oMod);
        } else if (SC_Input.iRoofShape == this.SATTEL) {
            // sRet = Rectangular.getRangeByModule(oMod);
            sRet = this.Rect_getRangeByModule(oMod);
        } else if (SC_Input.iRoofShape == this.WALM) {
            sRet = this.Hip_getRangeByModule(oMod);
            // sRet = Hip.getRangeByModule(oMod);
        } else if (SC_Input.iRoofShape == this.SCHED) {
            // sRet = Rectangular.getRangeByModule(oMod);
            sRet = this.Rect_getRangeByModule(oMod);
        } else if (SC_Input.iRoofShape == this.KRUEPPELWALM) {
            // sRet = PartialHip.getRangeByModule(oMod);
            sRet = this.PartialHip_getRangeByModule(oMod);
        } else if (SC_Input.iRoofShape == this.MANSARD) {
            sRet = this.Rect_getRangeByModule(oMod);
            // sRet = Rectangular.getRangeByModule(oMod);
        }
        return sRet;
    }

    // static Rect_getRangeByModule(panel: any): string {
    //     return "";
    // }

    public static Rect_getRangeByModule(oMod: any): string {
        if (Rectangular.rrFBottomLeft.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Rectangular.rrFBottomLeftV.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Rectangular.rrFBottomRight.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Rectangular.rrFBottomRightV.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Rectangular.rrFTopLeft.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Rectangular.rrFTopLeftV.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Rectangular.rrFTopRight.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Rectangular.rrFTopRightV.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Rectangular.rrGBottom.isModuleInRange(oMod)) {
            return 'g';
        }
        if (Rectangular.rrGLeft.isModuleInRange(oMod)) {
            return 'g';
        }
        if (Rectangular.rrGRight.isModuleInRange(oMod)) {
            return 'g';
        }
        if (Rectangular.rrGTop.isModuleInRange(oMod)) {
            return 'g';
        }
        return 'h';
    }

    public static Hip_getRangeByModule(oMod: any): string {
        if (Hip.rrFBottomLeft.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Hip.rrFBottomRight.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Hip.rrFSideLeft.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Hip.rrFSideRight.isModuleInRange(oMod)) {
            return 'f';
        }
        if (Hip.rrGBottom.isModuleInRange(oMod)) {
            return 'g';
        }
        if (Hip.rrGTop.isModuleInRange(oMod)) {
            return 'g';
        }
        return 'h';
    }

    public static PartialHip_getRangeByModule(oMod: any): string {
        if (PartialHip.rrFBottomLeft.isModuleInRange(oMod)) {
            return 'f';
        }
        if (PartialHip.rrFBottomLeftV.isModuleInRange(oMod)) {
            return 'f';
        }
        if (PartialHip.rrFBottomRight.isModuleInRange(oMod)) {
            return 'f';
        }
        if (PartialHip.rrFBottomRightV.isModuleInRange(oMod)) {
            return 'f';
        }
        if (PartialHip.rrFSideLeft.isModuleInRange(oMod)) {
            return 'f';
        }
        if (PartialHip.rrFSideRight.isModuleInRange(oMod)) {
            return 'f';
        }
        if (PartialHip.rrFTopLeftV.isModuleInRange(oMod)) {
            return 'f';
        }
        if (PartialHip.rrFTopRightV.isModuleInRange(oMod)) {
            return 'f';
        }
        if (PartialHip.rrGBottom.isModuleInRange(oMod)) {
            return 'g';
        }
        if (PartialHip.rrGLeft.isModuleInRange(oMod)) {
            return 'g';
        }
        if (PartialHip.rrGRight.isModuleInRange(oMod)) {
            return 'g';
        }
        if (PartialHip.rrGTop.isModuleInRange(oMod)) {
            return 'g';
        }
        return 'h';
    }
}
